import { z } from 'zod';
import { GUIDE_IDS } from '@/lib/guides/engine';

/**
 * What a chat reply asks the portal to do with a guide (#3898).
 * The server names an allowlisted id or control; anything else is dropped.
 */
const assistantGuideSchema = z.discriminatedUnion('kind', [
  z.object({
    kind: z.literal('start'),
    guideId: z.enum(GUIDE_IDS),
  }),
  z.object({
    kind: z.literal('control'),
    action: z.enum(['back', 'skip', 'cancel']),
  }),
]);

export type AssistantGuideCommand = z.infer<typeof assistantGuideSchema>;

/** A server command names an allowlisted guide or control, never an arbitrary action. */
export function parseAssistantGuide(value: unknown): AssistantGuideCommand | undefined {
  const parsed = assistantGuideSchema.safeParse(value);
  return parsed.success ? parsed.data : undefined;
}
